import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * /influencer-access — kept as a permanent redirect to /partner-access
 * after the rename. Preserves any ?code=… or #hash so existing creator
 * links keep working.
 */
const InfluencerAccess = () => {
  const { search, hash } = useLocation();
  useEffect(() => {
    // no-op; render path handles the redirect synchronously
  }, []);
  return <Navigate to={`/partner-access${search}${hash}`} replace />;
};

export default InfluencerAccess;

